import { SpinningLoader } from "risa-oasis-ui_v2";

interface InlineLoaderWithMessageProps {
  message: string;
  className?: string;
}

const InlineLoaderWithMessage = (props: InlineLoaderWithMessageProps) => {
  return (
    <div className={`flex items-center gap-2 ${props.className}`}>
      <SpinningLoader />
      <span className="text-small text-primaryGray-2">{props.message}</span>
    </div>
  );
};

export default InlineLoaderWithMessage;
